import { createAction, handleActions } from "redux-actions";
import * as R from "ramda";
import { EditorState, ContentState } from "draft-js";

export const pages = {
  list: "LIST",
  form: "FORM",
};

export const types = {
  ballsListLoad: "BALL_LIST_LOAD",
  // ballsListLoaded: 'BALL_LIST_LOADED',
  ballHandleForm: "BALL_HANDLE_FORM",
  // ballSetPhoto: 'BALL_SET_PHOTO',
  ballSet: "BALL_SET",
  ballError: "BALL_ERROR",
  // ballSaved: 'BALL_SAVED',
  ballChangeState: "BALL_CHANGE_STATE",
  // ballsChangePage: 'BALLS_CHANGE_PAGE',
  ballsChangeOrder: "BALLS_CHANGE_ORDER",
  ballSelect: "BALL_SELECT",
  ballSelected: "BALL_SELECTED",
  ballAddNew: "BALL_ADD_NEW",
  ballRemove: "BALL_REMOVE",
  ballTakePhoto: "BALL_TAKE_PHOTO",
  ballGalleryPhoto: "BALL_GALLERY_PHOTO",
  ballRemovePhoto: "BALL_REMOVE_PHOTO",
  ballSavePhoto: "BALL_SAVE_PHOTO",
  ballPhotoSaved: "BALL_PHOTO_SAVED",
  setCurrentBall: "SET_CURRENT_BALL",
  setLoadBalls: "SET_LOAD_BALLS",
  setArsenalFilter: "SET_ARSENAL_FILTER",
  ballNoteState: "BALL_NOTE_STATE",
  setJob: "SET_JOB",
  setJobs: "SET_JOBS",
  setCurrentJobs: "SET_CURRENT_JOBS",
  createJob: "CREATE_JOB",
  updateJob: "UPDATE_JOB",
  jobSelect: "JOB_SELECT",
  jobSelected: "JOB_SELECTED",
  jobHandleForm: "JOB_HANDLE_FORM",
  jobNoteState: "JOB_NOTE_STATE",
  jobNotifyCustomer: "JOB_NOTIFY_CUSTOMER",
  jobDetailCreate: "JOB_DETAIL_CREATE",
  jobDetailCreated: "JOB_DETAIL_CREATED",
  jobDelete: "JOB_DELETE",
  jobDeleted: "JOB_DELETED",
  jobDetailDelete: "JOB_DETAIL_DELETE",
  jobDetailDeleted: "JOB_DETAIL_DELETED",
  readBarcode: "READ_BARCODE",
  readBarcodeSuccess: "READ_BARCODE_SUCCESS",
  readBarcodeError: "READ_BARCODE_ERROR",
  readSerialText: "READ_SERIAL_TEXT",
  readSerialTextSuccess: "READ_SERIAL_TEXT_SUCCESS",
  readSerialTextError: "READ_SERIAL_TEXT_ERROR",
  readSerialBarcode: "READ_SERIAL_BARCODE",
  readSerialBarcodeSuccess: "READ_SERIAL_BARCODE_SUCCESS",
  readSerialBarcodeError: "READ_SERIAL_BARCODE_ERROR",
  getBallDatabaseInfo: "GET_BALL_DATABASE_INFO",
  getBallDatabaseInfoSuccess: "GET_BALL_DATABASE_INFO_SUCCESS",
  getBallDatabaseInfoScan: "GET_BALL_DATABASE_INFO_SCAN",
  setBallDatabaseInfo: "SET_BALL_DATABASE_INFO",
  getBallDatabaseSearch: "GET_BALL_DATABASE_SEARCH",
  getBallDatabaseSearchSuccess: "GET_BALL_DATABASE_SEARCH_SUCCESS",
  getBallDatabaseFiltersSuccess: "GET_BALL_DATABASE_FILTERS_SUCCESS",
  setOpenBallDatabaseSearch: "SET_OPEN_BALL_DATABASE_SEARCH",
  setShowConfirmDeleteArsenal: "SET_SHOW_CONFIRM_DELETE_ARSENAL",
};

export const ballsListLoad = createAction(types.ballsListLoad);

export const ballHandleForm = createAction(types.ballHandleForm);

export const ballSet = createAction(types.ballSet);

// export const ballSetPhoto = createAction(types.ballSetPhoto);

export const ballSelect = createAction(types.ballSelect);
export const ballSelected = createAction(types.ballSelected);

export const ballError = createAction(types.ballError);

// export const ballSaved = createAction(types.ballSaved);

// export const ballsChangePage = createAction(types.ballsChangePage);

export const ballAddNew = createAction(types.ballAddNew);

export const ballRemove = createAction(types.ballRemove);

export const ballTakePhoto = createAction(types.ballTakePhoto);

export const ballGalleryPhoto = createAction(types.ballGalleryPhoto);

export const ballRemovePhoto = createAction(types.ballRemovePhoto);

export const ballSavePhoto = createAction(types.ballSavePhoto);

export const ballPhotoSaved = createAction(types.ballPhotoSaved);

export const ballChangeState = createAction(types.ballChangeState);

export const ballsChangeOrder = createAction(types.ballsChangeOrder);

export const setCurrentBall = createAction(types.setCurrentBall);
export const setLoadBalls = createAction(types.setLoadBalls);
export const setArsenalFilter = createAction(types.setArsenalFilter);

export const ballNoteState = createAction(types.ballNoteState);

export const setJob = createAction(types.setJob);
export const setJobs = createAction(types.setJobs);
export const setCurrentJobs = createAction(types.setCurrentJobs);
export const createJob = createAction(types.createJob);
export const updateJob = createAction(types.updateJob);
export const jobSelect = createAction(types.jobSelect);
export const jobSelected = createAction(types.jobSelected);
export const jobHandleForm = createAction(types.jobHandleForm);
export const jobNoteState = createAction(types.jobNoteState);
export const jobNotifyCustomer = createAction(types.jobNotifyCustomer);
export const jobDetailCreate = createAction(types.jobDetailCreate);
export const jobDetailCreated = createAction(types.jobDetailCreated);

export const jobDelete = createAction(types.jobDelete);
export const jobDeleted = createAction(types.jobDeleted);
export const jobDetailDelete = createAction(types.jobDetailDelete);
export const jobDetailDeleted = createAction(types.jobDetailDeleted);

export const readBarcode = createAction(types.readBarcode);
export const readBarcodeSuccess = createAction(types.readBarcodeSuccess);
export const readBarcodeError = createAction(types.readBarcodeError);
export const readSerialText = createAction(types.readSerialText);
export const readSerialTextSuccess = createAction(types.readSerialTextSuccess);
export const readSerialTextError = createAction(types.readSerialTextError);
export const readSerialBarcode = createAction(types.readSerialBarcode);
export const readSerialBarcodeSuccess = createAction(
  types.readSerialBarcodeSuccess
);
export const readSerialBarcodeError = createAction(
  types.readSerialBarcodeError
);

export const getBallDatabaseInfo = createAction(types.getBallDatabaseInfo);
export const getBallDatabaseInfoSuccess = createAction(
  types.getBallDatabaseInfoSuccess
);
export const getBallDatabaseInfoScan = createAction(
  types.getBallDatabaseInfoScan
);
export const setBallDatabaseInfo = createAction(types.setBallDatabaseInfo);

export const getBallDatabaseSearch = createAction(types.getBallDatabaseSearch);
export const getBallDatabaseSearchSuccess = createAction(
  types.getBallDatabaseSearchSuccess
);

export const getBallDatabaseFiltersSuccess = createAction(
  types.getBallDatabaseFiltersSuccess
);

export const setOpenBallDatabaseSearch = createAction(
  types.setOpenBallDatabaseSearch
);

export const setShowConfirmDeleteArsenal = createAction(
  types.setShowConfirmDeleteArsenal
);

export const INITIAL_STATE = {
  loading: false,
  saving: false,
  balls: [],
  currentBall: {},
  currentPage: pages.list,
  error: null,
  ball: {},
  filter: "active",
  savingPhoto: false,
  noteEditorState: EditorState.createEmpty(),
  jobs: [],
  currentJobs: [],
  currentJob: {},
  jobNoteEditorState: EditorState.createEmpty(),
  creatingJobDetails: {},
  readingBarcode: false,
  gettingBallDatabaseInfo: false,
  settingBallDatabaseInfo: false,
  ballDatabaseBalls: [],
  ballDatabaseBallsTotalRecords: 0,
  ballDatabaseFilters: [],
  ballDatabaseSelectedBalls: [],
  openBallDatabaseSearch: false,
  showConfirmDeleteArsenal: false,
};

export const arsenalReducer = handleActions(
  {
    [types.ballAddNew]: (state) => ({
      ...state,
      settingBallDatabaseInfo: true,
    }),
    [types.ballHandleForm]: (state, action) => ({
      ...state,
      currentBall: {
        ...state.currentBall,
        ...action.payload.ball,
      },
    }),
    [types.ballsListLoad]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.ballSet]: (state, action) => {
      const ballIndex = R.findIndex(R.propEq("id", action.payload.ball.id))(
        state.balls
      );

      return {
        ...state,
        savingPhoto: false,
        currentBall: action.payload.ball
          ? {
              ...state.currentBall,
              ...action.payload.ball,
              spec_sheet_id: action.payload.ball.spec_sheet
                ? action.payload.ball.spec_sheet.id
                : action.payload.ball.spec_sheet_id,
            }
          : {},
        noteEditorState: EditorState.createWithContent(
          ContentState.createFromText(
            action.payload.ball && action.payload.ball.note
              ? action.payload.ball.note
              : ""
          )
        ),
        currentJobs: action.payload.ball ? action.payload.ball.jobs : [],
        loading: false,
        settingBallDatabaseInfo: false,
        balls: R.update(ballIndex, {
          ...state.currentBall,
          ...action.payload.ball,
          spec_sheet_id: action.payload.ball.spec_sheet
            ? action.payload.ball.spec_sheet.id
            : action.payload.ball.spec_sheet_id,
        })(state.balls),
      };
    },
    [types.setCurrentBall]: (state, action) => ({
      ...state,
      currentBall: action.payload.ball
        ? {
            ...action.payload.ball,
            spec_sheet_id: action.payload.ball.spec_sheet
              ? action.payload.ball.spec_sheet.id
              : action.payload.ball.spec_sheet_id,
          }
        : {},
      currentJobs: action.payload.ball ? action.payload.ball.jobs : [],
    }),
    [types.ballSelect]: (state, action) => ({
      ...state,
      savingPhoto: false,
      currentBall: action.payload.ball
        ? {
            ...action.payload.ball,
            spec_sheet_id: action.payload.ball.spec_sheet
              ? action.payload.ball.spec_sheet.id
              : action.payload.ball.spec_sheet_id,
          }
        : {},
      currentJobs: action.payload.ball ? action.payload.ball.jobs : [],
      noteEditorState: EditorState.createWithContent(
        ContentState.createFromText(
          action.payload.ball && action.payload.ball.note
            ? action.payload.ball.note
            : ""
        )
      ),
      loading: false,
      settingBallDatabaseInfo: false,
    }),
    [types.setLoadBalls]: (state, action) => ({
      ...state,
      balls: [...action.payload.balls],
      loading: false,
    }),
    [types.setArsenalFilter]: (state, action) => ({
      ...state,
      filter: action.payload.filter,
    }),
    [types.ballSavePhoto]: (state) => ({
      ...state,
      savingPhoto: true,
    }),
    [types.ballNoteState]: (state, action) => ({
      ...state,
      noteEditorState: action.payload.noteEditorState,
    }),
    [types.setJob]: (state, action) => ({
      ...state,
      currentJob: {
        ...action.payload.job,
        ball_id: action.payload.job.ball_id
          ? action.payload.job.ball_id
          : action.payload.job.ball.id,
      },
      currentJobs: R.insert(R.indexOf(R.propEq("id", action.payload.job.id)))(
        {
          ...action.payload.job,
          ball_id: action.payload.job.ball_id
            ? action.payload.job.ball_id
            : action.payload.job.ball.id,
        },
        state.currentJobs
      ),
    }),
    [types.setJobs]: (state, action) => ({
      ...state,
      jobs: action.payload.jobs,
    }),
    [types.setCurrentJobs]: (state, action) => ({
      ...state,
      currentJobs: action.payload.currentJobs,
    }),
    [types.jobSelect]: (state, action) => ({
      ...state,
      currentJob: action.payload.job,
    }),
    [types.jobNoteState]: (state, action) => ({
      ...state,
      jobNoteEditorState: action.payload.noteEditorState,
    }),
    [types.jobDetailCreate]: (state, action) => ({
      ...state,
      creatingJobDetails: {
        ...state.creatingJobDetails,
        [action.payload.service_id]: true,
      },
    }),
    [types.jobDetailCreated]: (state, action) => ({
      ...state,
      currentJob: {
        ...state.currentJob,
        job_details: [
          ...state.currentJob.job_details,
          action.payload.jobDetail,
        ],
      },
      creatingJobDetails: {
        ...state.creatingJobDetails,
        [action.payload.jobDetail.job_service.id]: false,
      },
    }),
    [types.jobDeleted]: (state, action) => ({
      ...state,
      currentJobs: state.currentJobs.filter(
        (job) => job.id !== action.payload.id
      ),
      currentJob: {},
    }),
    [types.jobDetailDelete]: (state, action) => ({
      ...state,
      creatingJobDetails: {
        ...state.creatingJobDetails,
        [action.payload.job_service_id]: true,
      },
    }),
    [types.jobDetailDeleted]: (state, action) => ({
      ...state,
      currentJob: {
        ...state.currentJob,
        job_details: state.currentJob.job_details.filter(
          (jobDetail) => jobDetail.id !== action.payload.id
        ),
      },
      creatingJobDetails: {
        ...state.creatingJobDetails,
        [action.payload.job_service_id]: false,
      },
    }),
    [types.readBarcode]: (state) => ({
      ...state,
      readingBarcode: true,
    }),
    [types.readBarcodeSuccess]: (state) => ({
      ...state,
      readingBarcode: false,
    }),
    [types.readSerialText]: (state) => ({
      ...state,
      readingBarcode: true,
    }),
    [types.readSerialTextSuccess]: (state) => ({
      ...state,
      readingBarcode: false,
    }),
    [types.readSerialBarcode]: (state) => ({
      ...state,
      readingBarcode: true,
    }),
    [types.getBallDatabaseInfoScan]: (state) => ({
      ...state,
      gettingBallDatabaseInfo: true,
      settingBallDatabaseInfo: true,
      openBallDatabaseSearch: false,
    }),
    [types.getBallDatabaseInfo]: (state) => ({
      ...state,
      gettingBallDatabaseInfo: true,
      ballDatabaseSelectedBalls: [],
    }),
    [types.getBallDatabaseInfoSuccess]: (state, action) => ({
      ...state,
      gettingBallDatabaseInfo: false,
      ballDatabaseSelectedBalls: action.payload.balls,
    }),
    [types.setBallDatabaseInfo]: (state) => ({
      ...state,
      settingBallDatabaseInfo: true,
    }),
    [types.getBallDatabaseSearch]: (state) => ({
      ...state,
      ballDatabaseBalls: [],
      ballDatabaseBallsTotalRecords: 0,
      ballDatabaseFilters: [],
      gettingBallDatabaseInfo: true,
    }),
    [types.getBallDatabaseSearchSuccess]: (state, action) => ({
      ...state,
      gettingBallDatabaseInfo: false,
      ballDatabaseBalls: action.payload.balls,
      ballDatabaseBallsTotalRecords: action.payload.totalRecords,
    }),
    [types.getBallDatabaseFiltersSuccess]: (state, action) => ({
      ...state,
      ballDatabaseFilters: action.payload.filters,
    }),
    [types.setOpenBallDatabaseSearch]: (state, action) => ({
      ...state,
      openBallDatabaseSearch: action.payload.open,
      settingBallDatabaseInfo:
        action.payload.settingBallDatabaseInfo !== undefined
          ? action.payload.settingBallDatabaseInfo
          : state.settingBallDatabaseInfo,
    }),
    [types.setShowConfirmDeleteArsenal]: (state, action) => ({
      ...state,
      showConfirmDeleteArsenal: action.payload,
    }),
  },
  INITIAL_STATE
);
